/**
 * BG Scroll Animations — IntersectionObserver-based reveal system
 * Handles: fade, slide, scale, stroke-draw, word-split, counters
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-bg-reveal]').forEach(function (el) {
      el.classList.add('bg-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bg-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function init() {
    document.querySelectorAll('[data-bg-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when Shopify theme editor reloads sections */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-bg-reveal]:not(.bg-revealed)').forEach(function (el) {
        observer.observe(el);
      });
    });
  }
})();
